import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });
  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}
